import { Injectable, Type } from "@angular/core";
import { PromiseBlotterLookupService } from "../../impl/PromiseBlotterLookupService";
import { ITradeDealPromiseLookupService } from "../ITradeDealPromiseLookupService";
import { IBasePrimeDependent } from "../../IBasePrimeDependent";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class TradeDealPromiseLookupService
  extends PromiseBlotterLookupService<string, CubiqTS.DealImpl>
  implements ITradeDealPromiseLookupService, IBasePrimeDependent
{
  constructor() {
    super();
  }

  abstract getTradeDeal(dealId: string): Promise<CubiqTS.DealImpl>;
  abstract getAllTradeDeals(): Promise<Array<CubiqTS.DealImpl>>;
  abstract addDependentPrime(dependentIsPrimed: Promise<boolean>): Promise<boolean>;
}
